
import React, { useState, useEffect, useCallback } from "react";
import TableAndSearch from "../common/TableAndSearch";
import { Link } from "react-router-dom";
import { encryptWithAES } from "components/common/encyptDecrypt";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import notificationService from "services/notification.service";
import LocalStorageService from "services/tokenlocalstorage.service";

var tempSearch;

export default function Asset(props) {

  const { headerFilter } = props;
  const [totalCount, setTotalCount] = useState(0);
  const [listData, setListData] = useState([]);
  const [search, setSearch] = useState("");

  const fetchAdminListData =  (searchString) => {

    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );

    var query =
      (headerFilterObj?.enterprise
        ? "&enterprise=" + headerFilterObj.enterprise
        : "") +
      (headerFilterObj?.stateId
        ? "&stateId=" + headerFilterObj?.stateId
        : "") +
      (headerFilterObj?.cityId
        ? "&cityId=" + headerFilterObj?.cityId
        : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&driverName=" + encodeURIComponent(searchString));

    query = query ? "?" + query : "";

    try {
        getRequestInAssets("driver/getAllDriver" + query)
        .then((res) => {
          if (res.data != null && res.data.length>0) {
            setListData(res?.data);
            props.userCount(res?.data.length);
            setTotalCount(res?.data.length)
          }else{
            setListData([]);
            props.userCount(0);
            setTotalCount(0)
          }
        })
        .catch((e) => {
            setListData([]);
            props.userCount(0);
            setTotalCount(0)
          console.log(e, "ERROR");
        });
    } catch (err) {
      // setListData([]);
      notificationService.showNonBlacklistedError(
        "",
        err?.response?.data?.message
      );
      console.error("Error", err);
    }
  };

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      fetchAdminListData();
    } else {
      fetchAdminListData(tempSearch);
    }
  }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    tempSearch = localStorage.getItem("lastTableSearch");
    if (headerFilterObj && Object.keys(headerFilterObj).length > 0) {
      fetchAdminListData(tempSearch);
    }
    if (headerFilterObj && !headerFilterObj) {
      headerFilter = false;
      setListData([]);
      fetchAdminListData(tempSearch);
    }
  }, [ headerFilter]);
   
  const columns = React.useMemo(() => [
    {
      Header: "Driver Name",
      accessor: "name",
      width: 163,
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.name? row.row?.original?.name : 'NA'}</div>
      ) },
    },
    {
        Header: "Email Id.",
        accessor: "email",
        width: 160,
        Cell: (row) => { 
            return(
              <div>{row.row?.original?.email? row.row?.original?.email : 'NA'}</div>
          ) },
      },
    {
      Header: "Contact No.",
      accessor: "mobile",
      width: 160,
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.mobile? row.row?.original?.mobile : 'NA'}</div>
      ) },
    },
    {
        Header: "DL No.",
        accessor: "dlNumber",
        width: 160,
        Cell: (row) => { 
            return(
              <div>{row.row?.original?.dlNumber? row.row?.original?.dlNumber : 'NA'}</div>
          ) },
      },
    {
      Header: "Action",
      accessor: "emailId",
      disableSortBy: true,
      width: 90,
      Cell: (row) => (
        <>
          <div>
            <Link to={`/Users/viewDriver/${row?.row?.original?.id}/view`}>
              <img
                src={require("assets/eye.png").default}
                style={{ margin: "8px" }}
              ></img>
            </Link>
            <Link
              to={`/Users/updateDriver/${row?.row?.original?.id}`}
            >
              <img src={require("assets/pencil.png").default}></img>
            </Link>
          </div>
        </>
      ),
    },
  ],[listData]);

  return (
    <div>
      <TableAndSearch
        totalCount={totalCount}
        searchOpts={{
          // onSearch: searchByAdminName,
          onSearch:fetchAdminListData,
          placeholder: "Search by Driver Name",
          setSearch: setSearch
        }}
        columns={columns}
        data={listData}
        tigger={props?.tigger}
        tabTemp= {props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={headerFilter}
      />
    </div>
  );
}
